import API from '@/services/api'

export default {
  authenticate() {
    return API.get('/account')
  },
  getAccounts() {
    return API.get('/accounts')
  },
  getAccount(id) {
    return API.get('/account/' + id)
  }
}
